module.exports = __webpack_public_path__ + "static/media/chhnl-logo-white.e32cdf41.png";